import { IApplicationState } from '../../types/redux';

export const selectResultsSubdomain = (state: IApplicationState) => {
  return state.results.subdomain;
};
